/// <reference path="../modules/app.module.ts" />
/// <reference path="../objects/interfaces/inavigationservice.ts" />

module App.Services {
    export class NavigationService implements App.Interfaces.INavigationService {
        static serviceId = 'navigationService';

        static $inject = [
            '$state',
            Blocks.RouterFactory.factoryId,
            Services.PipelineDataService.serviceId
        ];

        constructor(private $state: ng.ui.IStateService,
                    private routerFactory: Blocks.Interfaces.IRouterFactory,
                    public pipelineDataService: Services.IPipelineDataService) {

        }

        currentStep = (): Interfaces.ICustomState => {
            return <Interfaces.ICustomState>(this.$state.current);
        }

        previousStep = () => {
            var previousStep = this.getPreviousStep(this.$state.current);

            if (previousStep) {
                this.goToStep(previousStep.name);
            }
        }

        nextStep = () => {
            var nextStep = this.getNextStep(this.$state.current);

            if (nextStep) {
                this.goToStep(nextStep.name);
            }
        }

        goToStep = (name: string, replace?: boolean) => {
            var options = {};
            if (replace)
                options = { location: 'replace', reload: true, notify: false };

            this.$state.go(name, {}, options);
        }

        goToOpertation = (name: string) => {
            var states = this.routerFactory.states.filter((r) => {
                return r.operations.filter((o) => {
                    return o.toUpperCase() == name.toUpperCase();
                }).length == 1;
            });
            
            if (states.length > 0)
                this.goToStep(states[0].name);
        }

        goToStepNumber(stepNo: number): void {
            var states = this.routerFactory.states.filter((r) => {
                    return r.order== stepNo;
            });

            if (states.length > 0)
                this.goToStep(states[0].name);
        }

        goToStepIndex(index: number): void {
            var state = this.routerFactory.states[index];

            if (state != null)
                this.goToStep(state.name);
        }

        getPreviousStep = (state: Interfaces.ICustomState | ng.ui.IState) => {
            var currentIndex = this.routerFactory.states.findIndex(x => x.name == state.name);

            if (currentIndex > 0) {
                return <Interfaces.ICustomState>(this.routerFactory.states[currentIndex - 1]);
            }
            return null;
        }

        getNextStep = (state: Interfaces.ICustomState | ng.ui.IState) => {
            var currentIndex = this.routerFactory.states.findIndex(x => x.name == state.name);

            if (currentIndex < this.routerFactory.states.length - 1) {
                return <Interfaces.ICustomState>(this.routerFactory.states[currentIndex + 1]);
            }

            if (currentIndex >= 0)
                return <Interfaces.ICustomState>(this.routerFactory.states[currentIndex]);

            return null;
        }

        getStepByStepName = (stepName: string): Interfaces.ICustomState => {
            var states = this.routerFactory.states.filter((r) => {
                return r.configuratorStepName.indexOf(stepName) > -1;
            });

            if (states.length > 0)
                return states[0];

            return null;
        }

        getCurrentStepNumber = () => {
            return this.getStepNumber(this.currentStep());
        }

        getStepNumber = (stepToCompare): ng.IPromise<number> => {
            return this.pipelineDataService.getPipelineSteps().then((steps) => {
                var menuSteps = [];

                for (var item in steps) {
                    var state = this.getStepByStepName(steps[item]);
                    if (state != null && state.showInMenu && (menuSteps.filter((x) => x.name == state.name).length == 0)) {
                        menuSteps.push(state);
                    }
                }
                
                for (var i = 0; i < menuSteps.length; i++) {
                    var step = menuSteps[i];

                    if (step != null && step == stepToCompare) {
                        return i + 1;
                    }
                }

                return -1;
            }).catch((err) => {
                console.log('error step numbers: ' + JSON.stringify(err));
                return -1;
            });
        }

    }

    app.service(NavigationService.serviceId, NavigationService);
}